import { AdditionalAssetsValues } from '@theme/js/components/common/Game/enum';
import { IGame, IGameAsset, IGameTileAssetLayout, ITileSizes } from './types';

export * from '@core/js/hooks/games/helpers';

// #region @theme
export const getAdditionalAssetsImage = (assets: IGameAsset[], sizes: ITileSizes) => {
    const additionalSize = assets.find(({ name }) => {
        const validationRegExp = /^GAME_IMAGE_[3-8]_[1-2]/;
        const matchingRegExp = new RegExp(`^GAME_IMAGE_${sizes.width}_${sizes.height}`);

        return validationRegExp.test(name) && matchingRegExp.test(name);
    });

    return additionalSize?.url;
};

export const getRoundedImage = (assets: IGameAsset[], isRoundedCategory: boolean, isDesktop: boolean) => {
    if (!isRoundedCategory) {
        return '';
    }

    const image = assets.find(({ name }) =>
        isDesktop
        ? AdditionalAssetsValues.MAIN_IMAGE_ROUNDED.includes(name)
        : AdditionalAssetsValues.MOBILE_IMAGE_ROUNDED.includes(name)
    );

    return image?.url;
};

export const getImageStub = ({ width, height }: ITileSizes) => {
    if (width === 1 && height === 1) {
        return '';
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    // set image size
    canvas.width = 150 * width;
    canvas.height = 150 * height;

    if (ctx) {
        // fill background
        ctx.fillStyle = 'black';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // draw text
        ctx.textAlign = 'center';
        ctx.font = '3rem Roboto';
        ctx.fillStyle = '#79c000';
        ctx.fillText(`${width} x ${height}`, canvas.width / 2, canvas.height / 2);
    }

    return canvas.toDataURL();
};

export const getTileImage = (game: IGame,
    sizes = { width: 1, height: 1 },
    isRoundedCategory: boolean,
    isDesktop: boolean,
    isLoggedIn: boolean
) => {
    // We're taking only landscape images, as it's used as default for images rn.
    const { defaultGameImage: defaultImage, additionalAssets: assets, gameTileAssetsLandscape } = game;
    const layoutSelector = `layout${sizes.width}x${sizes.height}` as keyof IGameTileAssetLayout;
    const images = gameTileAssetsLandscape[layoutSelector] || {};

    const roundedIcon = getRoundedImage(assets, isRoundedCategory, isDesktop);
    const mainImage = isLoggedIn ? images.mainImage : images.guestMainImage || images.mainImage;
    const mobileImage = !isDesktop && (isLoggedIn ? images.mobileImage : images.guestMobileImage);
    const additionalLayoutImages = getAdditionalAssetsImage(assets, sizes) || getImageStub(sizes);

    return roundedIcon || mobileImage || mainImage || additionalLayoutImages || defaultImage;
};
// #endregion
